/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusTagMiniDto } from '../../models/lexplus-tag-mini-dto';

export interface UploadsControllerFindTagsV1$Params {
  kundeId: number;
  search?: string;
  limit?: number;
}

export function uploadsControllerFindTagsV1(http: HttpClient, rootUrl: string, params: UploadsControllerFindTagsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusTagMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerFindTagsV1.PATH, 'get');
  if (params) {
    rb.query('kundeId', params.kundeId, {});
    rb.query('search', params.search, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusTagMiniDto>>;
    })
  );
}

uploadsControllerFindTagsV1.PATH = '/v1/uploads/tags';
